import { Link } from "react-router-dom";
import { Coffee, ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";

export default function PaymentCancelPage() {
  const { t } = useLang();
  return (
    <div className="max-w-lg mx-auto px-4 sm:px-6 py-20">
      <div className="kawaii-card p-10 text-center kawaii-pop" data-testid="payment-cancel">
        <div className="mx-auto w-20 h-20 rounded-full bg-lavender/70 flex items-center justify-center mb-6">
          <Coffee className="w-9 h-9 text-ink" strokeWidth={2.2} />
        </div>
        <h1 className="font-display text-3xl sm:text-4xl text-ink">{t("payCancelTitle")}</h1>
        <p className="mt-3 text-ink-soft leading-relaxed">{t("payCancelSub")}</p>
        <div className="mt-8 flex flex-wrap gap-3 justify-center">
          <Link to="/pricing" data-testid="cancel-back-pricing-btn" className="kawaii-btn kawaii-btn-ink">{t("backToPricing")} <ArrowRight className="w-4 h-4" strokeWidth={2.5} /></Link>
          <Link to="/pdf" className="kawaii-btn">{t("pdfSheets")}</Link>
        </div>
      </div>
    </div>
  );
}
